import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-navIcon6",
  "use": "icon-navIcon6-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-navIcon6\"><path fill-rule=\"evenodd\" d=\"M5 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm2 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m5.862 3.3a.456.456 0 0 0-.017-.67.52.52 0 0 0-.707.017l-2.495 2.48-1.78-1.77a.52.52 0 0 0-.708-.016c-.2.18-.208.48-.017.669l2.364 2.35a.2.2 0 0 0 .282 0z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol